import { render, staticRenderFns } from "./myProgramPackBookPage.vue?vue&type=template&id=7a584767&scoped=true&"
import script from "./myProgramPackBookPage.vue?vue&type=script&lang=ts&"
export * from "./myProgramPackBookPage.vue?vue&type=script&lang=ts&"
import style0 from "./programPackBook.css?vue&type=style&index=0&id=7a584767&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a584767",
  null
  
)

export default component.exports